export class CurrencyUtils {

    public static formatValue(value: number): string {
        return (value/100).toLocaleString('it-IT', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        })
    }

    public static getIntVal(value: string): number {
        if(value === undefined || value === null || value === ""){
            return 0;
        } else {
            const replaced = value.replace(/[.,€\s]/g, '');
            return parseInt(replaced);
        }
    }
}